import { keycloak } from "@/entities/keycloak";
import { ApolloLink } from "@apollo/client";

export const authMiddleware = new ApolloLink((operation, forward) => {
  // const ctx = operation.getContext();
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => {
    return {
      headers: {
        ...headers,
        Authorization: `Bearer ${keycloak.token}`,
      },
    };
  });
  return forward(operation);
});
